type PageImageLoaderProps = { src: string; width?: number; quality?: number };

/**
 * Custom Next.js image loader for CMS media assets served by the backend.
 * Pass the full resolved URL (already including API_BASE) as `src`.
 * Next.js will call this with `{ src, width, quality }`.
 *
 * The backend `/api/public/{nicov,cms}/assets/*` endpoints serve original files and
 * does not support on-the-fly resize, so we just return the original URL.
 * Next.js still benefits from lazy-loading, async decoding, and the `srcset`
 * generation done by the Image component itself.
 */
export default function pageImageLoader({ src }: PageImageLoaderProps): string {
  return src;
}
